//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import SectionTemplate from './SectionTemplate.vue';
export default {
  extends: SectionTemplate,
  computed: {
    styles(){
      return {
        // 'background-image': 'url('+this.data.image+')'
      }
    }
  },
  mounted(){
    this._rotateText();
  },
  methods: {
    rotate(value){
      let endString = '';
      const matches = value.split('[')
      .filter(function(v){ return v.includes(']') > -1})
      .map( function(value) {
        if(value){
          const valueSplit = value.split(']');
          endString = valueSplit[1];
          return valueSplit[0];
        }
        return '';
      })

      if(matches.length === 1) return matches[0];

      return '<div>'+matches[0]+'</div>' + ('<span class="rotate-text">'+(matches[1].split(',')).map((text) => ('<span>'+text+'</span>')).join('')+'</span>') + (endString && endString.length > 0 ? '<div data-length="'+endString.length+'">'+endString+'</div>' : '');
    },
    _rotateText(){
      const self = this;
      setTimeout(function(){
        const $rotateText = $('#' + self.sectionID).find('.rotate-text').first();
        if($rotateText){
          const $rotateSpan = $rotateText.find('span');
          let $rotateSpanNow = 0;
          $rotateSpan.first().addClass('active');

          setInterval(function(){
            const $rotateSpanEl = $rotateSpan.eq($rotateSpanNow++);

            $rotateText.width($rotateSpanEl.width());

            $rotateSpanEl.addClass('active').siblings().removeClass('active');

            if($rotateSpanNow >= $rotateSpan.length) $rotateSpanNow = 0;
          },3000);
        }
      },500);
    }
  }
}
